import { Button, Alert, Form } from 'react-bootstrap';
import './ClaimBox.css';
import { useState, useEffect } from 'react';
import InfoForm from '../Form/Form';
import axios from 'axios';

import { useSearchParams } from 'react-router-dom'
import { useParams } from 'react-router-dom';

const ClaimBox = (props) => {

  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeId, setCodeId] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [error, setError] = useState("");


  // assuming a https://turo.getspiffy.com/?code=12345abcde format
  useEffect(() => {
    // useSearchParams did not work for mobile or safari
    // trying to just simply parse the url instead
    let url = window.location.href
    if (url.includes("code=")) {
      let params = url.split("code=").pop()
      setPromoCode(params)
    }
  }, [])


  // SHOULD CHECK IF PROMO CODE IS VALID
  // SEND TO FORM IF VALID TO FILL IN REST OF INFORMATION

  // {
  //   "expires": "2022-09-17T07:00:00Z"
  //   "id": "f47c2413-b467-4818-99f5-8c0dc55717e6"
  //   "promo_code": "testcode"
  //   "sku": "test"
  // }
  const checkPromoCode = async () => {

    await axios.get(`https://jfh5w19m1b.execute-api.us-east-1.amazonaws.com/promo_code?code=${promoCode}`).then(
      res => {
        if (res.status !== 200) {
          setError("Wrong or invalid promo code");
        } else {
          setCodeId(res.data['id']);
          setShowForm(true);
        }
        setLoading(false);
      }
    ).catch(error => {
      if (error.response.data.error && error.response.data.error_code === 0) {
        setError(error.response.data.error)
      } else {
        setError("Something went wrong submitting promo code");
      }

      setLoading(false);
    });

  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    await checkPromoCode();
  }


  const promoBox = () => {
    return (
      <div className='claimBoxContainer'>
        {loading ?
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          :
          <>
            <h1 className='claimHeader'>Enter your unique promo code to claim your Smart Tumbler Starter Kit</h1>
            <Form onSubmit={handleSubmit} className='headerInnerBox'>
              <Form.Control required placeholder='Promo Code: ' value={promoCode} onChange={(e) => { setPromoCode(e.target.value) }} className='promoInput' />
              <Button type="submit" className='promoBtn'>CLAIM</Button>
            </Form>
            <p className="shippingDisclaimer">Shipment time varies, but can be as much as 9 weeks from your order. Reach out to <a href="mailto:smarttumbler@getspiffy.com">smarttumbler@getspiffy.com</a> to check on order updates.</p>
          </>}
      </div>
    )
  }

  return (
    <div ref={props.refProps} className='claimBoxContainer'>
      {error ? <Alert variant="danger">{error}</Alert> : <></>}
      {showForm ? <InfoForm promoCode={promoCode} codeId={codeId} /> : promoBox()}
    </div>
  )
}

export default ClaimBox;